import React from "react";
import { cva } from "class-variance-authority";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { Download } from "lucide-react";
// Remove this line: import "tw-animate-css/dist/tw-animate.css";

export const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-blue-600 text-white hover:bg-primary-50 focus:ring-primary-500",
        secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-500",
        outline:
          "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        ghost:
          "hover:text-accent-foreground rounded-md focus:outline-none focus:ring-0 focus:ring-offset-0",
      },
      size: {
        sm: "px-3 py-1 text-xs",
        md: "px-4 py-2",
        lg: "px-6 py-3 text-lg",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
);

const Button = ({
  children,
  className,
  variant,
  size,
  showIcon = true,
  ...props
}) => {
  return (
    <button
      className={twMerge(
        buttonVariants({ variant, size }),
        "hover:scale-105 active:scale-95 transform transition-transform duration-150 ",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
